
const MoreFacets = () => {
  const $toggleButtons = document.querySelectorAll('.facet-group-toggle');

  $toggleButtons.forEach(item => {
    item.addEventListener('click', e => {
      e.preventDefault();
      const labelMore = item.dataset.labelMoreOptions;
      const labelLess = item.dataset.labelLessOptions;

      if (item.classList.contains('toggleButton')) {
        item.classList.remove('toggleButton');
        item.querySelector('span').innerText = labelMore;
        item.previousElementSibling
          .querySelectorAll('.toggled')
          .forEach(option => {
            option.classList.remove('toggled', 'd-flex');
            option.classList.add('d-none');
        });
      } else {
        item.classList.add('toggleButton');
        item.querySelector('span').innerText = labelLess;

        item.previousElementSibling
          .querySelectorAll('.d-none')
          .forEach(option => {
            option.classList.add('toggled', 'd-flex');
            option.classList.remove('d-none');
        });
      }
    });
  });
}

export default MoreFacets;
